
<template>
  <v-row
    v-resize="onResizeWindow"
    justify="center"
  >
    <v-col cols="12">
      <v-card>
        <v-toolbar class="primary">
          <v-toolbar-title>Профиль MAX</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="form.description"
                label="Описание"
              />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="form.clientId"
                :items="clients"
                label="Клиент"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="form.token"
                label="Токен"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="form.type"
                :items="[{text:'Только подтверждение возраста', value:0},{text:'Расширенный',value:1}]"
                label="Тип"
              />
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="form.rules.allow18PlusOnlyToAdults"
                label="Разрешать продажу товаров 18+ только совершеннолетним"
              />
            </v-col>
            <v-col
              v-if="form.type===1"
              cols="12"
              sm="6"
            >
              <v-checkbox
                v-model="form.rules.underAgeDiscount.enabled"
                label="Скидка несовершеннолетним"
              />
            </v-col>
            <v-col
              v-if="form.type===1"
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="form.rules.underAgeDiscount.percent"
                label="Размер скидки %"
                type="number"
              />
            </v-col>
            <v-col
              v-if="form.type===1"
              cols="12"
              sm="6"
            >
              <v-checkbox
                v-model="form.rules.studentDiscount.enabled"
                label="Скидка студентам"
              />
            </v-col>
            <v-col
              v-if="form.type===1"
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="form.rules.studentDiscount.percent"
                label="Размер скидки %"
                type="number"
              />
            </v-col>
            <v-col
              v-if="form.type===1"
              cols="12"
              sm="6"
            >
              <v-checkbox
                v-model="form.rules.pensionerDiscount.enabled"
                label="Скидка пенсионерам"
              />
            </v-col>
            <v-col
              v-if="form.type===1"
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="form.rules.pensionerDiscount.percent"
                label="Размер скидки %"
                type="number"
              />
            </v-col>
            <v-col
              v-if="form.type===1"
              cols="12"
              sm="6"
            >
              <v-checkbox
                v-model="form.rules.disabilityDiscount.enabled"
                label="Скидка инвалидам"
              />
            </v-col>
            <v-col
              v-if="form.type===1"
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="form.rules.disabilityDiscount.percent"
                label="Размер скидки %"
                type="number"
              />
            </v-col>
            <v-col
              v-if="form.type===1"
              cols="12"
              sm="6"
            >
              <v-checkbox
                v-model="form.rules.largeFamilyDiscount.enabled"
                label="Скидка многодетным"
              />
            </v-col>
            <v-col
              v-if="form.type===1"
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="form.rules.largeFamilyDiscount.percent"
                label="Размер скидки %"
                type="number"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row class="d-flex justify-sm-space-around">
            <v-col
              cols="12"
              sm="4"
              md="2"
            >
              <v-btn
                outlined
                color="primary"
                block
                @click="$router.go(-1)"
              >
                Отмена
              </v-btn>
            </v-col>
            <v-col
              v-if="!view"
              cols="12"
              sm="4"
              md="2"
            >
              <v-btn
                color="primary"
                block
                @click="onSave"
              >
                Сохранить
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import DatePicker from "@/views/loyalty/shared/components/date-picker/DatePicker.vue"
import DialogNomenclature from "@/views/loyalty/shared/components/dialog-nomenclature/DialogNomenclature.vue"
import { JustpayProfileService } from "@/views/loyalty/shared/services/justpay-profile-service"

export default {
  name: 'ProfileForm',
  components: { DatePicker, DialogNomenclature },
  props: ['create', 'change', 'view'],
  data: () => ({
    clients: [],
    form: {
      created: null,
      endDate: new Date().toISOString(),
      number: null,
      rules: {
        allow18PlusOnlyToAdults: true,
        underAgeDiscount: {
          enabled: false,
          percent: 0
        },
        studentDiscount: {
          enabled: false,
          percent: 0
        },
        pensionerDiscount: {
          enabled: false,
          percent: 0
        },
        disabilityDiscount: {
          enabled: false,
          percent: 0
        },
        largeFamilyDiscount: {
          enabled: false,
          percent: 0
        },
      },
      token: null,
      type: 0,
    },
    justpayProfileService: null,
  }),
  beforeMount () {
    this.justpayProfileService = new JustpayProfileService()
  },
  async mounted () {
    const profileId = this.$route.query.id
    const response = await this.justpayProfileService.getInit(profileId)
    if (profileId) {
      console.log('response', response)
      this.form = response.data
    }
    this.clients = response.clients
  },
  methods: {
    onResizeWindow () {
      const windowSize = { x: window.innerWidth, y: window.innerHeight }
      this.isWider = windowSize.x > windowSize.y
      this.isMobile = windowSize.x < 600
    },
    async onSave () {
      if (this.form.id) {
        await this.justpayProfileService.changeProfile(this.form)
      } else {
        await this.justpayProfileService.createProfile(this.form)
      }
      this.$router.go(-1)
    },
  }
}
</script>

<style scoped>

</style>
